import { takeEvery } from 'redux-saga/effects';
import { getEBillUser } from 'sdk/eBill';
import { LOAD } from 'model/eBillUser';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({ api: getEBillUser, dataName: ORM, type: LOAD })
  );
}
